const Marionette = require('backbone.marionette');
const templates = require('../templates');
const app = require('../app.js');

const FilterChildView = Marionette.ItemView.extend({
  template: templates.header_filter,
  serializeModel() {
    return {
      filter: this.model
    };
  },
  events: {
    'click .filter': 'displayFilter'
  },
  displayFilter() {
    app.vent.trigger('displayFastLoading');

    if (!this.model.get('active')) {
      this.model.set('active', true);
    } else {
      this.model.set('active', false);
    }

    app.vent.trigger('animateOverflowBookings');
  },
  modelEvents: {
    change: 'render'
  }
});

module.exports = Marionette.CompositeView.extend({
  template: templates.header_filters,
  childView: FilterChildView,
  childViewContainer: '.filters_list',
  events: {
    'click .remove_filters': 'removeFilters'
  },
  serializeData() {
    return {
      classWidth: this.collection.length > 7 ? 'eight' : 'seven'
    };
  },
  removeFilters() {
    app.vent.trigger('displayFastLoading');

    this.collection.each(filter => {
      filter.set('active', false);
    });

    app.vent.trigger('animateOverflowBookings');
  }
});



// WEBPACK FOOTER //
// ./src/views/header_filters.js